import React, { useEffect, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { UserContext } from "./UserContext";

/** NOTE: The role of the cypress user is set in Session storage at the beginning of the login process.
 * That role must be in place in order for this to work
 */

//TODO: create a query here that grabs all active modules and them maps over that list and assigns items to cypress user

function cypressUser({ role, jwt }) {
  return {
    umdId: "cypress-test-user",
    email: "cypress-test-user@utah.gov",
    firstName: "Cypress",
    lastName: "Test User",
    isActive: true,
    isStaff: true,
    isSysAdmin: role === "ADMIN" ? true : false,
    isPortalUser: false,
    assignments: [
      {
        moduleCode: "FU_MGMT",
        moduleAssigned: "File Upload Management",
        moduleRoute: "/ddw-admin/file-upload/file-upload-management",
        roleCode: role === "ADMIN" ? "ADMIN" : "WRITE"
      },
      {
        moduleCode: "PRTL",
        moduleAssigned: "Portal",
        moduleRoute: "/secure/portal-index",
        roleCode: role === "ADMIN" ? "ADMIN" : "WRITE"
      },
      {
        moduleCode: "RAE",
        moduleAssigned: "Rules & Enforcement",
        moduleRoute: "/secure/enforcements-dashboard",
        roleCode: role === "ADMIN" ? "ADMIN" : "WRITE"
      },
      {
        moduleCode: "SWR",
        moduleAssigned: "Statewide Reports",
        moduleRoute: "/secure/state-wide-reports",
        roleCode: role === "ADMIN" ? "ADMIN" : "WRITE"
      }
    ],
    jwt: jwt
  };
}

const CypressAuth = () => {
  const { setUser } = useContext(UserContext);
  const history = useHistory();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let jwt = params.get("jwt");
    let role = sessionStorage.getItem("cypress-role");
    if (role === "ADMIN") {
      let admin = cypressUser(role, jwt);
      setUser(admin);
    } else {
      let staff = cypressUser(role, jwt);
      setUser(staff);
    }
    history.push("/");
  }, [setUser, history]);

  return (
    <Row>
      <Col>
        <em>Redirecting ...</em>
      </Col>
    </Row>
  );
};

export default CypressAuth;
